import { ValutePlacanjaDto } from "src/app/models/sifrarnici/ValutePlacanjaDto";
import { BaseModel } from "./base.model";

export class VarijabilneValuteDto extends BaseModel {
    sifra: number;
    valuta: number;
    kurs: number;
    datum: string;
    valute: ValutePlacanjaDto;
}